// Edit these placeholders with your real details.
export const SITE = {
  name: "The Yard Party Project",
  area: "Pleasanton",
  areaNote: "Live in a surrounding city? Feel free to reach out and we'll see if we can accommodate.",
  email: "LPontzious@msn.com",
  phone: "510-552-7885",
};

export const PACKAGES = [
  {
    id: "mini",
    name: "The Mini Surprise",
    price: "$75",
    priceNum: 75,
    lookupKey: "mini_yard_sign",
    tagline: "A sweet little hello on the lawn.",
    color: "var(--sky)",
    features: ["Short greeting (e.g. HAPPY BDAY)", "4 party accents", "1 night on your lawn", "Set up before sunrise"],
  },
  {
    id: "grand",
    name: "The Grand Celebration",
    price: "$100",
    priceNum: 100,
    lookupKey: "grand_yard_sign",
    tagline: "Our most-booked lawn party.",
    color: "var(--coral)",
    featured: true,
    features: ["Full message + name", "10 party accents", "1 night on your lawn", "Set up + pick-up included", "Photo of the reveal sent to you"],
  },
  {
    id: "ultimate",
    name: "The Ultimate Yard Party",
    price: "$125",
    priceNum: 125,
    lookupKey: "ultimate_yard_sign",
    tagline: "Go big. Make the street stop.",
    color: "var(--grass)",
    features: ["Full message + name + age", "20+ accents & balloons", "Up to 2 nights", "Set up + pick-up included", "Kid-drawn custom card"],
  },
];

export const OCCASIONS = ["Birthday", "Graduation", "New Baby", "Anniversary", "Fun Run", "Back to School", "Welcome Home", "Something Else"];

// Swapped or extended anytime: after a real project, replace img with your own photo.
export const OCCASION_TILES = [
  { id: "birthday", label: "Birthdays", occasion: "Birthday", img: "/images/hero.jpg", span: "md:col-span-4 md:row-span-2", pos: "object-[50%_65%]" },
  { id: "grad", label: "Graduations", occasion: "Graduation", img: "/images/grad.jpg", span: "md:col-span-2 md:row-span-2", pos: "object-[50%_70%]" },
  { id: "baby", label: "New babies", occasion: "New Baby", img: "/images/baby.jpg", span: "md:col-span-2", pos: "object-[50%_75%]" },
  { id: "anniversary", label: "Anniversaries", occasion: "Anniversary", img: "/images/anniv.jpg", span: "md:col-span-2", pos: "object-[50%_70%]" },
  { id: "funrun", label: "Fun Runs", occasion: "Fun Run", img: "/images/funrun.jpg", span: "md:col-span-2", pos: "object-[50%_60%]" },
  { id: "school", label: "Back to School", occasion: "Back to School", img: "/images/school.jpg", span: "md:col-span-3", pos: "object-[50%_60%]" },
];

export const STEPS = [
  { n: "01", title: "You book", text: "Pick a package and the big day. Tell us who we're celebrating.", color: "var(--sun)" },
  { n: "02", title: "We plan", text: "The kids pick colors and accents. A parent confirms the details with you.", color: "var(--sky)" },
  { n: "03", title: "We plant", text: "Early morning, we sneak over and set it up. Parents drive, kids plant.", color: "var(--coral)" },
  { n: "04", title: "They smile", text: "Your person walks outside to a lawn full of love. We pick it up later.", color: "var(--grass)" },
];

export const CREW = [
  { name: "Gavin Reddy", role: "Chief Sign Planter", age: "age 9", color: "var(--coral)", bio: "Hi, I'm Gavin! I love playing the drums and basketball. I'm outgoing, have lots of energy, and love spending time with my friends and animals. I'm excited to start this business with my brother and help make your celebrations extra fun!" },
  { name: "Logan Reddy", role: "Head of Sparkle", age: "age 9", color: "var(--sun)", bio: "Hi, I'm Logan! I play the piano and trumpet, and I love hanging out with my friends. I'm excited to team up with my brother and friends, learn how to run a business, and help bring a birthday surprise or celebration to your front yard!" },
  { name: "Benjamin Herrick", role: "Money Counter", age: "age 10", color: "var(--sky)", bio: "Hi, I'm Benjamin! I love to play soccer and pay close attention to the little details. I'm excited to help set up your signs and make sure everything looks just right!" },
  { name: "Jackson Herrick", role: "Crew Captain", age: "age 13", color: "var(--grape)", bio: "Hi, I'm Jackson! I'm the oldest of the crew and love taking the lead. I enjoy solving Rubik's cubes and playing the guitar. I'm excited to help our team work together and bring a little extra fun to your celebrations!" },
  { name: "Lisa Pontzious", role: "Behind-the-Scenes Helper", age: "parent", color: "var(--grass)", bio: "Hi, I'm Lisa, Gavin and Logan's mom — and the extra set of hands behind their yard sign business. I love seeing the boys try something new and learn what it takes to earn, save, and work together. They bring the ideas and energy, and I help with the planning, transportation, and setup. We're excited to help our Pleasanton neighbors celebrate!" },
  { name: "Jennifer Herrick", role: "Queen of the Carpool", age: "parent", color: "var(--coral)", bio: "Hi, I'm Jennifer, Benjamin and Jackson's mom! I'm the queen of the carpool and an extra set of hands behind the crew. Between sports, school, and everything in between, I'm used to getting kids and their gear where they need to go. I'm excited to help the boys turn their teamwork into a business — and put those carpool skills to work delivering a little celebration to your yard!" },
];

export const FAQ = [
  { q: "When do you set up the sign?", a: "Usually early in the morning on the day you pick, so it's a surprise when they wake up. A parent is always with the kids." },
  { q: "How long does the sign stay up?", a: "Most packages stay for one night. We come back the next day to pick everything up." },
  { q: "What area do you cover?", a: `We serve ${SITE.area}. ${SITE.areaNote}` },
  { q: "What if it rains?", a: "Our signs are weatherproof. If the weather is really bad, we'll call you to move the date." },
  { q: "How do I pay?", a: "After you send a request, a parent will contact you to confirm the details and how to pay." },
  { q: "Where does the money go?", a: "Straight into the kids' savings jars." },
];
